<template>
  <div class="div" v-loading="loading">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="供应商资质资料" name="1"> </el-tab-pane>
      <el-tab-pane label="供应商项目资料" name="2"> </el-tab-pane>
      <el-tab-pane label="设备文档" name="3"> </el-tab-pane>
    </el-tabs>
    <!-- <div class="title">供应商管理</div> -->
    <div class="div" style="height: calc(100% - 55px)" v-if="activeName != 3">
      <div class="div-top">
        <SelectData
          v-model="searchData.SupplierId"
          :multiple="false"
          url="/PB/PB_Supplier/GetSupplierList"
          :option="{ label: 'Name', Id: 'Id' }"
          placeholder="请选择供应商"
          style="width: 250px"
        ></SelectData>
        <SelectData
          v-if="activeName == '2'"
          v-model="searchData.DocumentType"
          :multiple="false"
          url="/PB/PB_Supplier/GetDoctionData?DicKey=SupplierQualifications"
          :option="{ label: 'DicName', Id: 'DicValue' }"
          placeholder="请选择项目资料文件类型"
          style="width: 250px; margin-left: 10px"
        ></SelectData>
        <SelectData
          v-if="activeName == '1'"
          v-model="searchData.DocumentType"
          :multiple="false"
          url="/PB/PB_Supplier/GetDoctionData?DicKey=SupplierType"
          :option="{ label: 'DicName', Id: 'DicValue' }"
          placeholder="请选择资质资料文件类型"
          style="width: 250px; margin-left: 10px"
        ></SelectData>
        <el-input
          v-model="searchData.DocumentName"
          placeholder="请输入文件名称"
          style="width: 250px; margin-left: 10px"
          clearable
        ></el-input>
        <el-button
          type="primary"
          @click="handleSearch"
          style="margin-left: 10px"
          >查询</el-button
        >
      </div>
      <div class="div-center">
        <el-table
          :data="tableData"
          ref="table"
          style="width: 100%"
          height="calc(100% - 40px)"
          @selection-change="handleSelect"
        >
          <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="SupplierName"
            label="供应商名称"
            width="360px"
            align="center"
            sortable
          ></el-table-column>
          <el-table-column
            prop="TypeName"
            label="文件类型"
            width="200px"
            align="center"
            sortable
          ></el-table-column>
          <el-table-column
            prop="NewFileName"
            label="文件名称"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <a :href="scope.row.Url" target="_blank" style="color: #409eff">{{
                scope.row.NewFileName
              }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="CreateTime"
            label="移交日期"
            width="160px"
            sortable
          >
            <template slot-scope="scope">
              {{ moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.PageIndex"
            :page-sizes="pagination.PageSizes"
            :page-size="pagination.PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="w100" style="height: calc(100% - 55px)">
      <FileInfo ref="FileInfo" v-if="activeName === '3'" isTime></FileInfo>
    </div>
  </div>
</template>
<script>
import SelectData from '@/components/SelectData/SelectData'
import FileInfo from '@/views/DeviceAccounts/FileInfo/FileInfo'
import moment from 'moment'
export default {
  data() {
    return {
      activeName: '1',
      moment,
      searchData: {
        SupplierId: '',
        DocumentName: '',
        DocumentType: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { SelectData, FileInfo },
  methods: {
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      let url = ''
      if (this.activeName == '1') {
        url = '/PB/PB_Supplier/GetProjectSupplierTypeFilesList'
      } else {
        url = '/PB/PB_Supplier/GetProjectSupplierFilesList'
      }
      this.loading = true
      this.$http
        .post(url, {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          ...this.searchData,
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建供应商')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该供应商, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http.post('/PB/PB_Supplier/DeleteData', ids).then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('删除成功')
              this.getDataList()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑供应商', row)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {},
  watch: {
    activeName() {
      if (this.activeName == '3') {
        return
      }
      this.searchData = {
        SupplierId: '',
        DocumentName: '',
        DocumentType: '',
      }
      this.pagination = {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      }
      this.getDataList()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
